import { render, staticRenderFns } from "./UsersSubmenu.vue?vue&type=template&id=765391ff"
import script from "./UsersSubmenu.vue?vue&type=script&lang=js"
export * from "./UsersSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports